import { useAuthSiteStore } from '@/stores/AuthStore'
import axios from 'axios'
import { Notification } from './notifications'
import router from '@/router'
import { isErroSemAcessoOwner } from './errosSessao'

const request = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL_BACKEND,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
request.interceptors.request.use(
  function (config) {

    const authSiteStore = useAuthSiteStore()

    if (authSiteStore.token) {
      config.headers.set('Authorization', `Bearer ${authSiteStore.token}`)
    }

    // Faz alguma coisa antes da requisição ser enviada
    config.headers.set('owner-url', window.location.host)

    return config
  },
  function (error) {
    // Faz alguma coisa com o erro da requisição
    return Promise.reject(error)
  },
)

// Encerra a sessão e leva ao login do ambiente da rota atual (401 e 403 de owner)
function encerrarSessao(authSiteStore, mensagem) {
  const currentRoute = router.currentRoute.value
  const ambient = currentRoute.meta.ambient

  let destination = 'ecommerce-login'
  let params = {}

  if (ambient === 'afiliado-loja') {
    destination = 'affiliate-loja-login'
    if (currentRoute.params.code) {
      params = { code: currentRoute.params.code }
    }
  } else if (ambient === 'afiliado-portal') {
    destination = 'affiliate-portal-login'
  }

  authSiteStore.logout()

  // Evita disparar a notificação e o push se já estivermos na rota de login correta
  if (currentRoute.name !== destination) {
    Notification.info(mensagem)
    router.push({ name: destination, params })
  }
}

// Response interceptor
request.interceptors.response.use(
  function (response) {
    return response
  },
  async function (error) {
    const authSiteStore = useAuthSiteStore()

    if (error.response && error.response.status === 401) {
      encerrarSessao(authSiteStore, 'Sua sessão expirou. Por favor, faça login novamente.')
      return new Promise(() => {})
    }

    if (isErroSemAcessoOwner(error)) {
      encerrarSessao(authSiteStore, 'Sua sessão não é válida para esta empresa. Faça login novamente.')
    }

    return Promise.reject(error)
  },
)

export default request
